import {
    IntermediateProductListContextProvider,
    useIntermediateProductListContext,
} from "./IntermediateProductListContext";
import { useTranslation } from "react-i18next";
import { GridPageHeader } from "src/components/Grid/PageGridHeader";
import { IntermediateProductPopover } from "./Popover/IntermediateProductPopover";
import { ExtensionPoint, EXTENSION_POINTS } from "src/components/PuckExtensions";

import { IntermediateProductGrid } from "./ProductGrid/IntermediateProductGrid";
import { useMemo } from "react";
import { EntityListLayout } from "src/components/Grid/EntityListLayout";
import { useIsProductUxV2 } from "src/hooks/useIsProductUxV2";

const IntermediateProductListComponent = () => {
    const { t } = useTranslation();
    const isProductUxV2 = useIsProductUxV2();

    const { globalSearch } = useIntermediateProductListContext();
    const { search, setSearch } = globalSearch;
    const title = t("intermediate_products.list.title", "My intermediate products");

    const ProductGrid = useMemo(() => {
        return <IntermediateProductGrid />;
    }, []);

    return (
        <EntityListLayout
            appearance={isProductUxV2 ? "hub" : "legacy"}
            heading={<GridPageHeader title={title} />}
            ariaLabel={title}
            search={{
                value: search,
                onChange: setSearch,
                placeholder: t("intermediate_products.search", "Search an intermediate product"),
                showOnDesktop: false,
            }}
            actions={<IntermediateProductPopover />}
            beforeGrid={<ExtensionPoint extensionPoint={EXTENSION_POINTS.PRODUCT_LISTING_HEADER} priority="high" />}
            afterGrid={<ExtensionPoint extensionPoint={EXTENSION_POINTS.PRODUCT_LISTING_FOOTER} priority="high" />}
            hideHeadingOnMobile
        >
            {ProductGrid}
        </EntityListLayout>
    );
};

const IntermediateProductList = () => {
    return (
        <IntermediateProductListContextProvider>
            <IntermediateProductListComponent />
        </IntermediateProductListContextProvider>
    );
};
export default IntermediateProductList;
